// Écoutez les changements d'URL (pour la pagination dynamique)
const observer = new MutationObserver(() => {
  updateCanonical();
});

// Observer les changements dans le DOM (quand la pagination charge)
observer.observe(document.body, {
  childList: true,
  subtree: true
});

// Mettre à jour la canonical quand l'URL change
function updateCanonical() {
  const currentUrl = window.location.href;
  let canonicalLink = document.querySelector('link[rel="canonical"]');
  
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    document.head.appendChild(canonicalLink);
  }
  
  canonicalLink.href = currentUrl;
}

// Écouter aussi les changements d'historique (boutons précédent/suivant)
window.addEventListener('popstate', updateCanonical);

// Écouter les clics sur les liens de pagination
document.addEventListener('click', (e) => {
  if (e.target.closest('.pagination a, [data-pagination] a')) {
    setTimeout(updateCanonical, 100);
  }
});